import { Component, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-web-privacy-policy',
  templateUrl: './web-privacy-policy.component.html',
  styleUrls: ['./web-privacy-policy.component.scss']
})
export class WebPrivacyPolicyComponent {
  constructor (
    private readonly router: Router,
    private readonly renderer: Renderer2
  ) {

    this.router.events.subscribe(() => {
      this.renderer.removeClass(document.body, 'logged-in');
    });
  }
  
}
